var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCommonSpeaker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-1588.000000, -437.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Common/Speaker",
    transform: "translate(1588.000000, 437.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5289,5.787 C21.0349,5.131 21.9769,5.009 22.6329,5.515 L22.6329,5.515 L25.7259,7.899 C26.1209,8.204 26.3179,8.667 26.3049,9.13 C27.3809,10.083 27.9989,11.439 27.9949,12.882 L27.9949,12.882 L27.9839,17 L29.9999,17 L29.9999,28 C29.9999,30.209 28.2089,32 25.9999,32 L25.9999,32 L1.9999,32 L1.9999,21 C1.9999,18.791 3.7909,17 5.9999,17 L5.9999,17 L25.9839,17 L25.9949,12.877 C25.9979,11.987 25.6079,11.15 24.9269,10.577 C24.5689,10.605 24.2009,10.511 23.8939,10.275 L23.8939,10.275 L20.8009,7.891 C20.1459,7.385 20.0239,6.443 20.5289,5.787 Z M16.3462,9.5 C19.3842,9.5 21.8462,11.962 21.8462,15 L21.8462,15 L9.1542,15 C9.2132,11.948 11.7022,9.504 14.7552,9.5 L14.7552,9.5 Z M15.5,0 C17.571,0 19.25,1.679 19.25,3.75 C19.25,5.821 17.571,7.5 15.5,7.5 C13.429,7.5 11.75,5.821 11.75,3.75 C11.75,1.679 13.429,0 15.5,0 Z",
    id: 293
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonSpeaker);
export default __webpack_public_path__ + "static/media/common-speaker.a8245bce.svg";
export { ForwardRef as ReactComponent };